import { useState } from 'react';
import { createPortal } from 'react-dom';
import './unfilledAxesModal.scss';

/**
 * Модалка підтвердження збереження товару, в якого є оффери з незаповненими
 * осями варіацій. Показує підсумок і розгортний перелік: у якому оффері
 * (№ + артикул) які саме осі не заповнені.
 *
 * props:
 *  - data: { offers: [{ variantNo, sku, axes: string[] }] } | null
 *  - onCancel(): закрити без збереження
 *  - onConfirm(): зберегти попри незаповнені осі
 */
const UnfilledAxesModal = ({ data, onCancel, onConfirm }) => {
    const [expanded, setExpanded] = useState(false);

    if (!data || !Array.isArray(data.offers) || data.offers.length === 0) return null;

    const count = data.offers.length;

    // Рендеримо в body через портал, щоб position:fixed рахувався відносно
    // вьюпорта, а не трансформованих предків форми (інакше оверлей обрізається,
    // а модалка «з'їжджає»).
    return createPortal(
        <div className="unfilled-modal__overlay" role="dialog" aria-modal="true" onClick={onCancel}>
            <div className="unfilled-modal" onClick={(e) => e.stopPropagation()}>
                <div className="unfilled-modal__header">
                    <span className="unfilled-modal__icon" aria-hidden="true">⚠</span>
                    <h3 className="unfilled-modal__title">Є незаповнені осі варіацій</h3>
                </div>

                <p className="unfilled-modal__summary">
                    {count === 1
                        ? 'У 1 варіації не заповнені деякі параметри (напр. Колір, Розмір, Матеріал).'
                        : `У ${count} варіаціях не заповнені деякі параметри (напр. Колір, Розмір, Матеріал).`}
                    {' '}Товар можна зберегти, але краще перевірити.
                </p>

                <button
                    type="button"
                    className="unfilled-modal__toggle"
                    onClick={() => setExpanded((v) => !v)}
                    aria-expanded={expanded}
                >
                    {expanded ? '▾ Сховати деталі' : '▸ Показати, де саме не заповнено'}
                </button>

                {expanded && (
                    <ul className="unfilled-modal__list">
                        {data.offers.map((offer) => (
                            <li className="unfilled-modal__item" key={`${offer.variantNo}-${offer.sku}`}>
                                <span className="unfilled-modal__variant">
                                    Варіація №{offer.variantNo}
                                    {offer.sku ? ` (${offer.sku})` : ''}
                                </span>
                                <span className="unfilled-modal__axes">
                                    {offer.axes.join(', ')}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}

                <div className="unfilled-modal__footer">
                    <button type="button" className="unfilled-modal__btn unfilled-modal__btn--ghost" onClick={onCancel}>
                        Скасувати
                    </button>
                    <button type="button" className="unfilled-modal__btn unfilled-modal__btn--primary" onClick={onConfirm}>
                        Зберегти все одно
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default UnfilledAxesModal;
